import * as React from 'react';
import { styles } from './Styles';

const WelcomeText = "We want to provide you with personalized results to give you the best experience with the app. To do this, we need to collect some personal information. This information will be used to match you with other reviewers that are most like you, and have the same needs. We will not share this information with anyone."

export default ({onSubmit}) => (
		<div>
				<h1>Welcome</h1>
				<span>{WelcomeText}</span>
		</div>
);



// WEBPACK FOOTER //
// ./src/app/containers/Wizard/Pages/Intro.tsx